import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as types from './actionTypes.predefinedScripts';
import * as errorSaga from '../errors/saga.errors';
import Api from '../../api/Api';
import { IBaseAction } from '../base';

export interface IGetPredefinedScriptsParam {
    sluVersion: string
}

export function* getPredefinedScripts({ sluVersion }: IGetPredefinedScriptsParam) {
    try {
        const predefinedScripts = yield call(Api.getPredefinedScripts, sluVersion);
        yield put({ type: types.GET_PREDEFINED_SCRIPTS_OK, predefinedScripts });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* watch() {
    yield takeEvery<IGetPredefinedScriptsParam & IBaseAction>(types.GET_PREDEFINED_SCRIPTS_REQ, getPredefinedScripts);
}